import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';

import { IntlMsg } from '../../_core/IntlMsg/intl-msg.component';
import { messages } from './my-assignments.messages';

interface IAssignmentNoticeProps {
  message: React.ReactNode;
  onBack: () => void;
}

// Terminal "nothing to score here" state with a single Back-to-Assignments action,
// shared by the missing-assignment and empty-items branches of the scoring screen.
export const AssignmentNotice: React.FC<IAssignmentNoticeProps> = ({ message, onBack }) => (
  <Box>
    <Alert severity="info">{message}</Alert>
    <Box mt={2}><Button onClick={onBack}><IntlMsg {...messages.backToAssignments} /></Button></Box>
  </Box>
);
